import React, { useState, useCallback, useEffect, useRef,useContext } from "react";
// import { useGlobalContext } from "../../context/context";
import { FaChevronDown } from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import { MdOutlineDone } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import Law from "./Law";
import { DataContext } from '../context/DataProvider';

const SearchableDropDownReLaw = ({LawTitle}) => {
  const [pageNumber, setPageNumebr] = useState(1);
  const [openMenu, setOpenMenu] = useState(false);
  const observe = useRef();
  const [searchText, setSearchText] = useState(""); 
  const [lawTitle, setLawTitle] = useState(LawTitle);
  const {caseData, setcaseData,OptionSearch, setOption,fetchListReSection }: any =
  useContext(DataContext);
  const { loading, error, hasMore, ReLawArray } = Law(
    searchText,
    pageNumber,
  );
  const handelChange = (e) => {
    setSearchText(e.target.value);
    setPageNumebr(1);
    setLawTitle(e.target.value)
    // setsearchtitleid(e.target.value);
  };
  const handleonClick = () => {
    setOpenMenu(!openMenu);
  };
  // console.log()
  const lastorgElement = useCallback(
    (node) => {
      if (loading) return;
      if (observe.current) observe.current.disconnect();
      observe.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumebr((prevPageNumber) => prevPageNumber + 1);
          // console.log("visiable");
        }
      });
      //   if (node) observer.current
      //   console.log(node);
      if (node) observe.current.observe(node);
    },
    [loading, hasMore],
  );
  const handleClick = (item:any) => {
    setcaseData((caseData:any) => ({
      ...caseData,
      reLaw_ID: isNaN(parseInt(item.value)) ? '' : parseInt(item.value),
    }));
    setOption({
      value: item.value,
    label: item.label,
    })
    setOpenMenu(false);
    setLawTitle(item.label)
    fetchListReSection(item.value)
  
  };
  // console.log("handleClick in Searchable",OptionSearch)

  const emptyInput = (e:any) => {
    e.preventDefault();
    setLawTitle("")
    setcaseData((caseData:any) => ({
      ...caseData,
      reLaw_ID: 0,
    }));
    setSearchText("")
    // setclickText("");
    // setsearchtitleid("");
    setOpenMenu(false);
  };
  return (
  <>
    <div className="w-full flex flex-col">
        <div className=" ltr py-1  flex items-center">
          <input
            className="border border-gray-200 text-[14px] p-2 absolute  rounded-md w-[80%] text-right"
           
            placeholder="...جستجوی قانون  "
            onChange={handelChange}
            onClick={handleonClick}
            value={lawTitle}
          />
          <div className="relative  flex items-center justify-center  rounded-md px-2">
            {openMenu ? (
              <>
                <button className=" ltr   text-center">
                  <FaChevronDown className="text-[20px] text-gray-400" />
                </button>
                <div className="text-gray-400">|</div>
              </>
            ) : (
              <>
                <button className="" onClick={emptyInput}>
                  <IoIosClose className="text-[20px] text-gray-400" />
                </button>
              </>
            )}
          </div>
          {/* <div className=""><FaChevronDown /></div> */}
        </div>
        {openMenu && (
          <div
        className= "w-[80.5%] bg-white absolute rtl z-10 h-40 border-2 rounded-md mt-9  left-10 overflow-y-auto"
          >
            {Array.from(ReLawArray).map((i, index) => {
              if (Array.from(ReLawArray).length === index + 1) {
                return (
                  <>
                    <div
                      onClick={() => handleClick(i)}
                      ref={lastorgElement}
                      key={i.index}
                      className="cursor-pointer text-justify hover:bg-blue-100 py-2 px-1"
                    >
                      <p className="pr-2 text-justify flex item-center ">
                        {/* <MdOutlineDone className="pl-2 text-[2rem]" /> */}
                        {i.label}
                      </p>
                      <p className="text-[15px] text-gray-400 p-2"> {i.date}</p>
                    </div>
                  </>
                );
              } else {
                return (
                  <>
                    <div
                      onClick={() => handleClick(i)}
                      className="cursor-pointer text-justify hover:bg-blue-100 py-2 px-1"
                      key={i.index}
                    >
                      <p className="pr-2 text-justify flex item-center ">
                        {/* <MdOutlineDone className="pl-2 text-[2rem]" /> */}
                        {i.label}
                      </p>

                      <p className="text-[15px] text-gray-400 p-2"> {i.date}</p>
                    </div>
                    <hr />
                  </>
                );
              }
            })}

            <div>{loading && "loading..."}</div>
            {/* {error && <div>error...</div>} */}
          </div>
        )}
      </div>
  
  </>
  )
}

export default SearchableDropDownReLaw
